export enum cooperationModeEnum {
  常规采销 = 1,
  一件代发 = 2,
  代销 = 3,
}
